









































































































































































































































import Vue from "vue";
import { mapActions, mapGetters, mapState } from "vuex";
import moment from "moment";

import { Step } from "@/shared/interfaces/Step.interface";

import iwProgressionStatus from "./ProgressionStatus.vue";
import iwDraftModeButton from "./DraftModeButton.vue";
import iwEditionModeButton from "./EditionModeButton.vue";

import { updateClassified, validationClassified } from "@/shared/scripts/ValidateData";
import { Trans } from "@/shared/scripts/helpers/translation/translation";
import { WizardState } from "@/shared/interfaces/WizardState.interface";
import { OrderApiError } from "@/shared/interfaces/order/Order.interface";
import { i18n } from "@/shared/scripts/helpers/translation/i18n";
import missingCustomerNameMixin from "@/shared/mixins/missingCustomerName";

export default missingCustomerNameMixin.extend({
    name: "ProgressionWizard",
    components: {
        iwProgressionStatus: iwProgressionStatus,
        iwDraftModeButton: iwDraftModeButton,
        iwEditionModeButton: iwEditionModeButton,
        //iwTooltip
    },
    props: {
        // steps: {
        //     type: Array as () => Step[],
        //     required: true
        // },
        isEditionMode: {
            type: Boolean,
            required: true
        },
        displayButtons: {
            type: Boolean,
            required: false,
            default: true,
        }
    },
    data: function() {
        return {
            isMobile: true as boolean,
            documentScrollTop: 0 as number,
            listOpen: false as boolean,
            firstFocusableElement: null as unknown as HTMLElement,
            lastFocusableElement: null as unknown as HTMLElement,
        };
    },
    computed: {
        ...mapState("FormModule", ["classifiedId", "lastSave"]),
        ...mapState("StepsWizard", {
            currentStep: state => (state as WizardState).current,
            groups: state => (state as WizardState).groups,
            validatedSteps: state => (state as WizardState).validated,
            steps: state => (state as WizardState).steps,
            indexVisited: state => (state as WizardState).indexVisited
        }),
        ...mapGetters({
            hasErrorInCurrentGroup: "StepsWizard/hasErrorInCurrentGroup",
            getStep: "StepsWizard/getStep",
        }),
        urlPreview: function(): string {
            return `${process.env.VUE_APP_IMMOWEB_URL}/${Trans.currentLocale}${process.env.VUE_APP_CLASSIFIEDS_MANAGEMENT_PREVIEW_URL}${this.$t("classified")}/`;
        },
        classifiedLastSave: function(): string | null {
            if (this.lastSave) {

                const localizedDate = moment(this.lastSave).locale(Trans.currentLocale);

                const lastSaveDay = localizedDate.format("D");
                const lastSaveMonth = localizedDate.format("MMM");
                const lastSaveHour = localizedDate.format("HH");
                const lastSaveMinute = localizedDate.format("mm");

                return this.$t("last_saved_the_x_at_x", {day: lastSaveDay + " " + lastSaveMonth, hour: lastSaveHour + ":" + lastSaveMinute}) as string;
            }

            return null;
        }
    },
    mounted: function(): void {
        this.$responsive.registerMediaQuery("from-desktop", () => {
            this.isMobile = false;
            this.listOpen = true;
        }, () => {
            this.isMobile = true;
            this.listOpen = false;
        });
    },
    methods: {
        ...mapActions("OrdersModule", ["createOrder", "createTransaction"]),
        updateClassified: function(stepname: string) {
            if (this.isEditionMode) {
                validationClassified(() => {
                    return this.routeToPage(stepname);
                });
            } else {
                updateClassified((success:boolean) => {
                    if(success) {
                        if(stepname === "step-payment") {
                            this.createOrderAndRoute(stepname);
                        } else {
                            this.routeToPage(stepname);
                        }
                    } else {
                        if(["step-pricing", "step-payment"].includes(stepname) || (this.currentStep.step === "step-property-type" && !this.getPropertyType())) {
                            return false;
                        } else {
                            this.routeToPage(stepname);
                        }
                    }
                });
            }
        },
        createOrderAndRoute: function(stepname: string): void {
            // IO-154: creating the order emits the B2C log to Salesforce, so require a usable
            // customer name first. No loading flag is set on this path, so a bare return leaves
            // the sidebar usable.
            if (this.blockOnMissingCustomerName(() => this.createOrderAndRoute(stepname))) {
                return;
            }

            this.createOrder()
                .then(() => {
                    this.routeToPage(stepname);
                })
                .catch((errors: Array<OrderApiError>) => {
                    if (this.openModalOnMissingCustomerNameError(errors, () => this.createOrderAndRoute(stepname))) {
                        return;
                    }
                    this.dialog.alert(i18n.t("server_not_responding_error").toString());
                });
        },
        goToStep: function(stepname: string) {
            if(this.isEditionMode) {
                return validationClassified((success:boolean) => {
                    if(success) {
                        this.routeToPage(stepname);
                    }
                });
            }
        },
        toggleList: function() {
            if (this.listOpen === true) {
                this.closeList();
            } else {
                this.openList();
            }
        },
        openList: function() {
            this.listOpen = true;

            Vue.nextTick(() => {
                const progressionWizardBody = document.getElementById("progression-wizard-body");

                let focusableElements = [] as Array<HTMLElement>;

                if (progressionWizardBody) {
                    focusableElements = Array.from(progressionWizardBody.querySelectorAll(
                        "a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), [tabindex=\"0\"]"
                    ));
                }

                if (focusableElements.length > 0) {
                    this.firstFocusableElement = focusableElements[0];
                    // Save last focusable element of the modal
                    this.lastFocusableElement = focusableElements[focusableElements.length - 1];
                }

                if(this.isMobile){
                    this.documentScrollTop = (
                        document.scrollingElement ||
                        document.documentElement ||
                        document.body.parentNode ||
                        document.body
                    ).scrollTop;
                    // Add a Modal-Open class on html tag (disable scroll in css)
                    if(!document.documentElement.classList.contains("js-fullscreen")){
                        document.documentElement.classList.add("js-fullscreen");
                    }

                    // Add a Modal-Open class on html tag (disable scroll in css)
                    if(!document.documentElement.classList.contains("progress-bar-open")){
                        document.documentElement.classList.add("progress-bar-open");
                    }
                }

                if (this.firstFocusableElement) {
                    this.firstFocusableElement.focus();
                }
            });
        },
        closeList: function() {
            if(this.listOpen === true) {

                if(this.isMobile && (document.documentElement.classList.contains("js-fullscreen"))) {
                    window.scroll(0, this.documentScrollTop);

                    document.documentElement.classList.remove("js-fullscreen");
                    document.documentElement.classList.remove("progress-bar-open");
                }
                this.listOpen = false;
            }
        },
        openPreview: function() {
            if(this.urlPreview) {
                window.open(this.urlPreview + this.classifiedId, "_blank");
            }
        },
        isDisabled: function(step: Step): boolean {
            if(typeof step.isDisabled === "function") {
                return step.isDisabled();
            }
            return false;
        }
    },
});
